import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { EmployeeDetails } from "./employee-details.entity";

// import { VendorsPriceList } from "../vendors-price-list/entities/vendor-price-list.entity";

@Entity('employee_family_details')
export class EmployeeFamilyDetails {

    @PrimaryGeneratedColumn("increment", { name: 'employee_family_id' })
    employeeFamilyId: number;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "family_mem_name"
    })
    familyMemName: string;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "relation"
    })
    relation: string;
    @Column("datetime", {
        nullable: true,
        name: "fam_date_of_birth"
    })
    famDateOfBirth: Date;

    @Column("varchar", {
        nullable: true,
        name: "fam_aadhaar_no"
    })
    famAadhaarNo: string;

    @Column("varchar", {
        nullable: true,
        name: "contact_no"
    })
    contactNo: string;

    @Column("boolean", {
        nullable: true,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => EmployeeDetails, empInfo => empInfo.familyDetails, { nullable: true, })
    @JoinColumn({ name: "employee_id" })
    employeeDetails: EmployeeDetails;


}
